var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.869 15.869 17l-3.395-3.394 1.132-1.132L17 15.87zM7.4 12.2a4.805 4.805 0 0 1-4.8-4.8c0-2.646 2.154-4.8 4.8-4.8s4.8 2.154 4.8 4.8c0 2.647-2.154 4.8-4.8 4.8zM7.4 1a6.4 6.4 0 1 0 0 12.8A6.4 6.4 0 0 0 7.4 1z",
    fill: "#FFF",
    stroke: "#FFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconWhite);
export default __webpack_public_path__ + "static/media/search-icon-white.ee54893df4e4938ddc64c1baab8c2f6a.svg";
export { ForwardRef as ReactComponent };